if (!customElements.get('everso-gallery')) {
  customElements.define('everso-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const viewer = this.querySelector('.es-gallery__items');
      const items = Array.from(this.querySelectorAll('.es-gallery__item'));
      const buttons = Array.from(this.querySelectorAll('.es-gallery__thumb'));
      const status = this.querySelector('.es-gallery__status');
      const update = (index) => {
        buttons.forEach((button,i) => button.setAttribute('aria-pressed',String(i === index)));
        if (status) status.textContent = `${index + 1} / ${items.length}`;
      };
      buttons.forEach((button,index) => button.addEventListener('click', () => {
        const offset = items[index].offsetLeft - items[0].offsetLeft;
        viewer.scrollTo({left: offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        update(index);
      }));
      let frame = 0;
      viewer.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const origin = viewer.getBoundingClientRect().left;
          let best = 0;
          items.forEach((item,index) => {
            if (Math.abs(item.getBoundingClientRect().left-origin) < Math.abs(items[best].getBoundingClientRect().left-origin)) best=index;
          });
          update(best);
        });
      }, {passive:true});
      this.classList.add('is-enhanced');
      update(0);
    }
  });
}
